import { QRCodeSVG } from 'qrcode.react';

export default function QRCard({ qrUrl, eventName, date, hour, userName, dni }) {

  return (
    <div className="flex flex-col items-center justify-between h-full w-full p-6 text-center">
      
      {/* 1. Header: Nombre del Evento y Fecha */}
      <div className="flex flex-col items-center space-y-2 mb-6">
        <h2 
          className="text-2xl font-bold text-white tracking-wide leading-tight drop-shadow-md"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          {eventName}
        </h2>
        <div className="flex flex-col text-white/80 text-sm font-medium">
          <span className="uppercase tracking-wider">{date}</span>
          <span className="text-white/60">{hour}</span>
        </div>
      </div>

      {/* 2. QR Code (Central) */}
      <div className="bg-white p-4 rounded-2xl shadow-2xl mx-auto my-auto aspect-square flex items-center justify-center w-[240px]">
        
        {/* CASO 1: Aún no hay URL (Cargando) */}
        {!qrUrl ? (
          <div className="flex flex-col items-center justify-center text-gray-300">
            <div className="w-8 h-8 border-4 border-gray-200 border-t-black rounded-full animate-spin mb-2"></div>
            <span className="text-xs font-mono text-black/50">Generando...</span>
          </div>
        ) : 
        
        /* CASO 2: Es una imagen (URL http...) */
        qrUrl.startsWith('http') && !qrUrl.includes('{') ? (
          <img 
            src={qrUrl} 
            alt="QR Code" 
            className="w-full h-full object-contain" 
          />
        ) : (
          
        /* CASO 3: Es texto/JSON (Generar SVG) */
          <QRCodeSVG
            value={qrUrl}
            size={220}
            level="M"
            includeMargin={true}
            className="w-full h-full"
          />
        )}
      </div>

      {/* 3. Footer: Datos del Usuario */}
      <div className="mt-8 space-y-1 w-full border-t border-white/10 pt-6">
        <div className="uppercase text-[10px] tracking-[0.2em] text-white/40 mb-1">
          Titular de la entrada
        </div>
        <div 
          className="text-xl font-semibold text-white tracking-wide"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          {userName}
        </div>
        {dni && (
          <div className="text-sm text-white/50 font-mono tracking-wider">
            DNI: {dni}
          </div>
        )}
      </div>

    </div>
  );
}